import { ThemeProvider } from '@fairygodboss/ui';
import type { AppProps } from 'next/app';
import React from 'react';

import { ModalTrigger } from '../components/Auth/ModalTrigger';
import Layout from '../components/Layout';
import Seo from '../components/Seo';

import '../styles/base.scss';
import '../styles/_vars.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-quill/node_modules/quill/dist/quill.snow.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime';

const FGBApp = ({ Component, pageProps }: AppProps) => (
    <>
        <Seo />
        <ThemeProvider>
            <Layout pageProps={pageProps}>
                <ModalTrigger />
                <Component {...pageProps} />
            </Layout>
        </ThemeProvider>
    </>
);

export default FGBApp;
